import { defaultOrdersParams } from '@afterpaytouch/portal-api/consumer/ordertransactions'
import {
  useConsumerHasPreferredPaymentMethod,
  useConsumerIdentityIsValid,
  useGetCreditCardsQuery,
  useGetOrderTransactionsQuery,
  useHasOrderTransactions,
  useHasPreferredCreditCard,
} from '../../'
import { isExistingUser } from './utils'

export const useAccountProgressionIsExistingUser = (): boolean => {
  useGetCreditCardsQuery()
  useGetOrderTransactionsQuery(defaultOrdersParams)

  const hasOrders = useHasOrderTransactions()
  const identityIsValid = useConsumerIdentityIsValid()

  const consumerHasPreferredCreditCard = useHasPreferredCreditCard()
  const consumerHasPreferredPaymentMethod = useConsumerHasPreferredPaymentMethod()
  const hasPreferredPaymentMethod = consumerHasPreferredPaymentMethod || consumerHasPreferredCreditCard

  return isExistingUser(identityIsValid, hasPreferredPaymentMethod, hasOrders)
}
